import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

interface QuickActionsContextType {
  openCreatePatientModal: () => void;
  openCreateUserModal: () => void;
  createPatientModalOpen: boolean;
  createUserModalOpen: boolean;
  closeCreatePatientModal: () => void;
  closeCreateUserModal: () => void;
}

const QuickActionsContext = createContext<QuickActionsContextType | undefined>(undefined);

interface QuickActionsProviderProps {
  children: React.ReactNode;
}

export const QuickActionsProvider: React.FC<QuickActionsProviderProps> = ({ children }) => {
  const [createPatientModalOpen, setCreatePatientModalOpen] = useState(false);
  const [createUserModalOpen, setCreateUserModalOpen] = useState(false);
  const navigate = useNavigate();

  const openCreatePatientModal = () => {
    navigate('/patients?action=create');
    setCreatePatientModalOpen(true);
  };
  
  const openCreateUserModal = () => {
    navigate('/users?action=create');
    setCreateUserModalOpen(true);
  };
  
  const closeCreatePatientModal = () => setCreatePatientModalOpen(false);
  const closeCreateUserModal = () => setCreateUserModalOpen(false);

  return (
    <QuickActionsContext.Provider
      value={{
        openCreatePatientModal,
        openCreateUserModal,
        createPatientModalOpen,
        createUserModalOpen,
        closeCreatePatientModal,
        closeCreateUserModal,
      }}
    >
      {children}
    </QuickActionsContext.Provider>
  );
};

export const useQuickActions = (): QuickActionsContextType => {
  const context = useContext(QuickActionsContext);
  if (!context) {
    throw new Error('useQuickActions must be used within a QuickActionsProvider');
  }
  return context;
};